const listeners = new Set();

export const onOwnEntryCreated = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const announceOwnEntry = (groupId) =>
  listeners.forEach((listener) => listener(groupId));
